import React from 'react';
import { ViewportCanvas } from '../../viewport/ViewportCanvas';

export interface ScientificViewportShellProps {
  children?: React.ReactNode;
}

/**
 * ScientificViewportShell
 *
 * Dominant central workspace region.
 * Hosts the ViewportCanvas surface connected directly to the Visualization Worker.
 */
export const ScientificViewportShell: React.FC<ScientificViewportShellProps> = ({ children }) => {
  return (
    <div className="ssw-viewport-stage" role="region" aria-label="Scientific Viewport">
      {children || <ViewportCanvas />}
    </div>
  );
};

export default ScientificViewportShell;
